export function ClearCoursePath(name) {
  const split = name.split("_");
  return split[0];
}
